import React from "react";
import { XCircle } from "lucide-react";

const Invalidated: React.FC = () => {
  return (
    <div className="flex min-h-[300px] items-center justify-center py-8">
      <div className="space-y-4 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <XCircle className="h-8 w-8 text-red-600" />
        </div>
        <h3 className="text-lg font-semibold text-red-600">
          Reporte Invalidado o Desactivado
        </h3>
        <p className="text-sm text-gray-600">
          Contacta a tu asesor para generar un nuevo reporte.
        </p>
      </div>
    </div>
  );
};

export default Invalidated;
